import { render, staticRenderFns } from "./PublicAreaContainer.vue?vue&type=template&id=6554364e&scoped=true"
import script from "./PublicAreaContainer.vue?vue&type=script&lang=js"
export * from "./PublicAreaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554364e",
  null
  
)

export default component.exports